import { type FC } from 'react'

import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { gkAirAccessorGetProductDiscount } from '../../model/gkAirAccessorGetProductDiscount'

type GkAirProductImageDiscountProps = {
  product: GkAirRecommendedProductDataWeb
}

export const GkAirProductImageDiscount: FC<GkAirProductImageDiscountProps> = ({
  product,
}) => {
  const discount = gkAirAccessorGetProductDiscount(product)

  if (!discount) {
    return null
  }

  return (
    <span className="absolute right-2.5 top-3.5 block aspect-square w-12 rounded-full bg-light-tertiary text-center font-mono font-medium leading-[48px] text-dark-primary-max">
      {discount}
    </span>
  )
}
